export const getDate = (date) => {
  if (date === undefined) return;
  // Treats the string as local time -- BUT READ BELOW, this varied
  var d = new Date(date?.replace(" ", "T"));

  return d.toLocaleDateString();
};

export const getDateTime = (date) => {
  let utcDate = new Date(date);
  return utcDate.toLocaleString();
};

export const getPhoneNumberMask = (phoneNumber) => {
  if (phoneNumber === undefined || phoneNumber === null || phoneNumber === "")
    return "";

  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
};

export const getFormattedAddress = (address) => {
  if (address === undefined || address === null || address === "") return "";
  return address.replace(", USA", "");
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
